var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_586_950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 56,
    width: 22,
    height: 86,
    rx: 6,
    transform: "rotate(-90 108 56)",
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 199L32 52C32 50.8954 32.8954 50 34 50L104 50L104 42L34 42C28.4771 42 24 46.4772 24 52L24 199C24 204.523 28.4771 209 34 209L268 209C273.523 209 278 204.523 278 199L278 52C278 46.4772 273.523 42 268 42L198 42L198 50L268 50C269.105 50 270 50.8954 270 52L270 199C270 200.105 269.105 201 268 201L34 201C32.8954 201 32 200.105 32 199Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 74,
    width: 206,
    height: 113,
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 94,
    width: 22,
    height: 22,
    rx: 6,
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 142,
    width: 22,
    height: 22,
    rx: 6,
    stroke: "currentColor",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 95H234",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 116H234",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 144H233",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 164H202",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M300 53L315 53L315 172L315 182L323 182L323 174L323 53L323 45L315 45L300 45L292 45L292 53L292 174L292 182L300 182L300 174L300 172L300 53Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.75,
    y: 33.75,
    width: 9.5,
    height: 7.5,
    stroke: "currentColor",
    strokeWidth: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5 208.852L291.999 182.002L323.002 182.002L307.5 208.852Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_586_950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 350,
    fill: "white",
    transform: "translate(0 240) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrga);
export default __webpack_public_path__ + "static/media/orga.4548ce1ff49efd38f298f8d1fc8b6408.svg";
export { ForwardRef as ReactComponent };